import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

// styles
import { SideNavContainer, IntegrationCardContainer, IntegrationsContainer, StyledSelect, StyledInput, StyledInputGroup, SideNavFooter, Header, HeaderTitle } from './styles';

// Redux
import { apiAddCommsRequest, apiPatchCommsRequest } from 'Redux/actions/channel';

// Config
import { OrgIntegrations } from 'Config/integrationsConstant';

const ProjectIntegrationSidebarContent = ({
	onRightNavClose,
	projectId,
	selectedIntegrationId = null, // If pass, means Edit buttton is clicked.
}) => {
	const dispatch = useDispatch();

	// useSelector
	const channelState = useSelector(state => state.channel);
	const auth = useSelector(state => state.auth);

	const [integrationDataArr, setIntegrationDataArr] = useState([{
		type: 'discord',
		title: '',
		url: ''
	}]);

	const onDataChange = (idx, newValue, key) => {
		const newIntegrationDataArr = [...integrationDataArr];
		newIntegrationDataArr[idx][key] = newValue;
		setIntegrationDataArr(newIntegrationDataArr);
	};

	const onAddBtnClick = () => {
		const newIntegrationDataArr = [...integrationDataArr];
		newIntegrationDataArr.push({
			type: 'discord',
			title: '',
			url: '',
		});
		setIntegrationDataArr(newIntegrationDataArr);
	};

	const onDeleteBtnClick = (selectedIndex) => {
		const newIntegrationDataArr = integrationDataArr.filter((_, idx) => idx !== selectedIndex);
		setIntegrationDataArr(newIntegrationDataArr);
	};

	const onCancelBtnClick = () => {
		setIntegrationDataArr([]);
		onRightNavClose();
	};

	const onApplyBtnClick = () => {
		const findNoTitle = integrationDataArr.filter(integration => typeof integration?.title === "string" && integration?.title.trim() === "");
		if (findNoTitle.length !== 0) {
			toast.error('Please enter a title for each integration',{
				autoClose: 3500,
				hideProgressBar: false,
			});
			return;
		}
		if (selectedIntegrationId) { // Update
			const updateIntegrationData = {
				type: integrationDataArr[0].type,
				title: integrationDataArr[0].title,
				url: integrationDataArr[0].url,
			};
			dispatch(apiPatchCommsRequest(selectedIntegrationId, projectId, updateIntegrationData, auth.token));
		} else { // Create
			const createCommCardData = {
				project: projectId,
				commsData: integrationDataArr,
			};
			dispatch(apiAddCommsRequest(createCommCardData, auth.token));
		};
		setIntegrationDataArr([]);
		onRightNavClose();
	}

	useEffect(() => {
		// If selected, load the selected Integration details
		if (selectedIntegrationId && channelState?.projectComms?.length) {
			const selectedIntegration = {...channelState?.projectComms.find(projectComm => projectComm.id === selectedIntegrationId)}; // Use shallow clone to copy Redux data before putting it into local state.
			if (selectedIntegration) {
				setIntegrationDataArr([selectedIntegration]);
			}
		}
	}, [selectedIntegrationId, channelState?.projectComms]);

	return (
		<SideNavContainer>
			<IntegrationsContainer>
				{integrationDataArr.map((integrationData, idx) => (
					<IntegrationCardContainer key={`${integrationData?.id || idx}`}>
						<Header>
							<HeaderTitle>
								Integration #{idx+1}
							</HeaderTitle>
							{!selectedIntegrationId && (idx > 0) && (
								<Button variant="danger" size="sm" onClick={() => {onDeleteBtnClick(idx)}}>
									Delete
								</Button>
							)}
						</Header>
						<StyledInputGroup>
							<span>Type</span>
							<StyledSelect  value={integrationData?.type} onChange={(e) => {onDataChange(idx, e.target.value, 'type')}}>
								{Object.entries(OrgIntegrations).map(([integrationType, integrationDetails]) => (
									<option key={integrationType} value={integrationType}>{integrationDetails?.name}</option>
								))}
							</StyledSelect>
						</StyledInputGroup>

						<StyledInputGroup>
							<span>Title</span>
							<StyledInput
								type="text"
								value={integrationData?.title}
								onChange={(e) => {onDataChange(idx, e.target.value, 'title')}}
								placeholder="Enter the title"
							/>
						</StyledInputGroup>

						<StyledInputGroup>
							<span>URL</span>
							<StyledInput
								type="text"
								value={integrationData?.url}
								onChange={(e) => {onDataChange(idx, e.target.value, 'url')}}
								placeholder="Enter the URL"
							/>
						</StyledInputGroup>
					</IntegrationCardContainer>
				))}
			</IntegrationsContainer>
			<SideNavFooter>
				<Button variant="secondary" size="sm" onClick={onCancelBtnClick}>
					Cancel
				</Button>
				{!selectedIntegrationId && (
					<Button variant="success" size="sm" onClick={onAddBtnClick}>
						Add Another
					</Button>
				)}
				<Button variant="primary" size="sm" onClick={onApplyBtnClick}>
					Apply
				</Button>
			</SideNavFooter>
		</SideNavContainer>
	);
};

export default ProjectIntegrationSidebarContent;
